var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSystemLog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_315_5840",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_315_5840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.05 2.5C6.80832 2.38333 3.33332 5.79167 3.33332 10H1.84165C1.46665 10 1.28332 10.45 1.54998 10.7083L3.87498 13.0417C4.04165 13.2083 4.29998 13.2083 4.46665 13.0417L6.79165 10.7083C7.04998 10.45 6.86665 10 6.49165 10H4.99998C4.99998 6.75 7.64999 4.125 10.9167 4.16667C14.0167 4.20833 16.625 6.81667 16.6667 9.91667C16.7083 13.175 14.0833 15.8333 10.8333 15.8333C9.49165 15.8333 8.24999 15.375 7.26665 14.6C6.93332 14.3417 6.46665 14.3667 6.16665 14.6667C5.81665 15.0167 5.84165 15.6083 6.23332 15.9083C7.49999 16.9083 9.09165 17.5 10.8333 17.5C15.0417 17.5 18.45 14.025 18.3333 9.78333C18.225 5.875 14.9583 2.60833 11.05 2.5ZM10.625 6.66667C10.2833 6.66667 9.99999 6.95 9.99999 7.29167V10.3583C9.99999 10.65 10.1583 10.925 10.4083 11.075L13.0083 12.6167C13.3083 12.7917 13.6917 12.6917 13.8667 12.4C14.0417 12.1 13.9417 11.7167 13.65 11.5417L11.25 10.1167V7.28333C11.25 6.95 10.9667 6.66667 10.625 6.66667Z",
    fill: "black"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_315_5840)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_315_5840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemLog);
export default __webpack_public_path__ + "static/media/system-log.704f476712008a87d0f40c504fcd8560.svg";
export { ForwardRef as ReactComponent };